module.exports = {
  groups: ($stateParams, Api) ->
    Api.ManagedGroup.query().$promise

  client: ($stateParams, Api) ->
    Api.ManagedClient.query().$promise
}
